/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsmodeauto3Inputs */

const en_listingbuttonsmodeauto3 = /** @type {(inputs: Listingbuttonsmodeauto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic`)
};

const de_listingbuttonsmodeauto3 = /** @type {(inputs: Listingbuttonsmodeauto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch`)
};

/**
* | output |
* | --- |
* | "Automatic" |
*
* @param {Listingbuttonsmodeauto3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsmodeauto3 = /** @type {((inputs?: Listingbuttonsmodeauto3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsmodeauto3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsmodeauto3(inputs)
	return de_listingbuttonsmodeauto3(inputs)
});
export { listingbuttonsmodeauto3 as "listingButtonsModeAuto" }